import { api } from './client';

export interface LoginResponse {
  token: string;
  userId: string;
  email: string;
  licenseStatus: 'none' | 'active' | 'revoked';
  expiresAt: number;
}

export interface MeResponse {
  id: string;
  email: string;
  licenseStatus: 'none' | 'active' | 'revoked';
  purchasedAt: number | null;
  deviceCount: number;
}

export const authApi = {
  login: (email: string) =>
    api.post('api/auth/session', { json: { email } }).json<LoginResponse>(),

  logout: () => api.delete('api/auth/session'),

  me: () => api.get('api/auth/me').json<MeResponse>(),
};
